/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateContractorPenaltyCommandResult } from '../../models/create-contractor-penalty-command-result';

export interface ApiContractorPenaltiesCreateContractorPenaltyPost$Plain$Params {
      body?: {
'ProjectDailyTaskReportId'?: string;
'ProjectPenaltyDetailsTemplateId'?: string;
'Attachments'?: Array<Blob>;
}
}

export function apiContractorPenaltiesCreateContractorPenaltyPost$Plain(http: HttpClient, rootUrl: string, params?: ApiContractorPenaltiesCreateContractorPenaltyPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateContractorPenaltyCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiContractorPenaltiesCreateContractorPenaltyPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateContractorPenaltyCommandResult>;
    })
  );
}

apiContractorPenaltiesCreateContractorPenaltyPost$Plain.PATH = '/api/ContractorPenalties/CreateContractorPenalty';
